import { AxiosInstance } from 'axios';

import { insertId } from '../insertId';
import { toResponse } from '../genericToResponse';
import { cancellable } from '../cancellable';

export default (api: AxiosInstance, url: string) =>
  (marketId: string, templateId: string) => {
    const urlWithMarketId = insertId(url, marketId);
    const urlWithIds =
      templateId !== '-1'
        ? insertId(urlWithMarketId, templateId)
        : urlWithMarketId.substring(0, urlWithMarketId.length - 2);

    return cancellable<any>(
      (cancelOptions: any) => api.get(urlWithIds, cancelOptions),
      toResponse
    );
  };



// WEBPACK FOOTER //
// ./src/services/api/linkUpload/getParameterItems.ts